import type { ReactNode } from 'react';
import styles from './ChartFrame.module.css';
import type { AnchoredTooltip } from './useAnchoredTooltip';

/**
 * Positions an anchored readout inside `ChartFrame`'s `hover` slot.
 *
 * It exists so the five Recharts charts do not each have to import
 * `ChartFrame.module.css` to reach one class. Everything it knows is in
 * `surfaceProps` — the anchor's coordinates, which side of the point the bubble
 * takes, and whether it is locked — all decided by `useAnchoredTooltip`.
 *
 * Renders nothing while no point is anchored, so a caller can pass it
 * unconditionally.
 */
export function AnchoredTooltipSurface({
  anchor,
  children,
}: {
  anchor: AnchoredTooltip;
  children: ReactNode;
}) {
  if (!anchor.surfaceProps) return null;

  return (
    <div className={styles.hoverAnchor} {...anchor.surfaceProps}>
      {children}
    </div>
  );
}
